<script setup lang="ts">
import { PV, useToast } from "@/widgets";
import { useClipboard } from "@vueuse/core";
import { useId, watch } from "vue";
import CopyIcon from "~icons/mdi/content-copy";

const props = defineProps<{
    label: string;
    content: string;
}>();

const slots = defineSlots<{
    icon?: () => unknown;
}>();

const id = useId();
const toast = useToast();
const clipboard = useClipboard({ source: props.content });

watch(
    () => clipboard.copied.value,
    (copied) => {
        console.log(copied);
        if (copied) {
            toast.add({
                closable: false,
                group: "copy",
                summary: "INFORMASI",
                detail: "Teks telah disalin ke clipboard.",
                life: 2000,
            });
        }
    },
);
</script>

<template>
    <div class="flex flex-col gap-1">
        <div class="flex flex-row items-center px-1 justify-between">
            <label class="text-gray-800 font-semibold inline-flex flex-row items-center gap-1 mr-2" :for="id">
                {{ props.label }}
            </label>
        </div>

        <PV.IconField>
            <PV.InputIcon v-if="slots.icon !== undefined" class="-mt-2.5!">
                <slot name="icon"></slot>
            </PV.InputIcon>
            <PV.InputText :id="id" class="rns-input-static" disabled fluid :value="props.content" />
            <PV.InputIcon v-tooltip.left="'Salin'">
                <CopyIcon
                    class="text-gray-500 hover:text-gray-700 hover:cursor-pointer"
                    @click="clipboard.copy(props.content)"
                />
            </PV.InputIcon>
        </PV.IconField>
    </div>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-input-static {
    @apply bg-transparent! shadow-none! px-2! pt-2.25!;
    @apply text-black! border-gray-500! text-center!;
}
</style>
